const Lesson = (r) =>
  require.ensure([], () => r(require('@/views/lesson/index.vue')), 'Lesson')

export default [
  {
    path: 'lesson',
    name: 'lesson',
    component: Lesson,
  },
]
